import { Tabs } from "../../shared";
import ViewBasicLoginUser from "./ViewBasicLoginUser";
import UpdateBasicLoginUser from "./UpdateBasicLoginUser";
import ProfileActivation from "./ProfileActivation";
import ResetPassword from "./ResetPassword";
import PermissionManager from "./PermissionManager";

const SubComponent = ({ data }) => {
    const { id, status, domainName } = data;

    return (
        <Tabs
            tabItems={[
                {
                    id: `view-${id}`,
                    name: "View User",
                    content: <ViewBasicLoginUser data={data} />,
                },
                {
                    id: `update-${id}`,
                    name: "Update User",
                    content: <UpdateBasicLoginUser data={data} />,
                },
                {
                    id: `profile-activation-${id}`,
                    name: "Profile Activation",
                    content: <ProfileActivation id={data.id} userStatus={status} />,
                },
                {
                    id: `reset-password-${id}`,
                    name: "Reset Password",
                    content: <ResetPassword id={id} />,
                },
                {
                    id: `permission-${id}`,
                    name: "Permission",
                    content: <PermissionManager id={id} domains={domainName || []} />,
                },
            ]}
        />
    );
};

export default SubComponent;
